// ORGANISATIONS
export function UPDATE_ORGANISATIONS(state, data) {
  state.organisations = data
}
export function CLEAR_ORGANISATIONS(state) {
  state.organisations = []
}
export function UPDATE_ORGANISATION(state, data) {
  state.organisation = data
}
export function CLEAR_ORGANISATION(state) {
  state.organisation = null
}

// DASHBOARD/STATS
export function UPDATE_POST_COUNTER(state, data) {
  state.postCounter = data
}

export function UPDATE_STUDENT_REACH(state, data) {
  state.studentReach = data
}

export function UPDATE_SCHOOLS_COUNT(state, data) {
  state.schoolsCount = data
}

export function UPDATE_SCHOOLS(state, data) {
  state.schools = data
}

export function UPDATE_REGIONS(state, data) {
  state.regions = data
}

export function UPDATE_MAILOUTS(state, data) {
  state.mailouts = data
}

export function UPDATE_POST_CATEGORIES(state, data) {
  state.postCategories = data
}

export function UPDATE_POST_CATEGORIES_COUNT(state, data) {
  state.postCategoriesCount = data
}

export function UPDATE_TOP_POSTS(state, data) {
  state.topPosts = data
}

export function UPDATE_ORGANISATION_ACTIVITY(state, data) {
  state.organisationActivity = data
}

export function UPDATE_ORGANISATION_POST_SHARES(state, data) {
  state.organisationActivity = {
    ...state.organisationActivity,
    postShares: data,
  }
}

export function UPDATE_ORGANISATION_POST_REACH(state, data) {
  state.organisationActivity = {
    ...state.organisationActivity,
    postReach: data,
  }
}

export function UPDATE_ORGANISATION_POST_CATEGORIES(state, data) {
  state.organisationActivity = {
    ...state.organisationActivity,
    postCategories: data,
  }
}

export function UPDATE_ORGANISATION_POST_CATEGORIES_COUNT(state, data) {
  state.organisationActivity = {
    ...state.organisationActivity,
    postCategoriesCount: data,
  }
}

export function UPDATE_CONNECTIONS_IMPRESSIONS(state, data) {
  state.connectionsImpressionsCount = data
}

export function CLEAR_CONNECTIONS_IMPRESSIONS(state) {
  state.connectionsImpressionsCount = 0
}

export function UPDATE_CONNECTIONS_VIEWS(state, data) {
  state.connectionsViewsCount = data
}

export function CLEAR_CONNECTIONS_VIEWS(state) {
  state.connectionsViewsCount = 0
}

export function UPDATE_CONNECTIONS_CONTACTED(state, data) {
  state.connectionsContactedCount = data
}

export function CLEAR_CONNECTIONS_CONTACTED(state) {
  state.connectionsContactedCount = 0
}

export function UPDATE_CONNECTIONS_STATS(state, data) {
  state.connectionsWithStats = data
}

export function CLEAR_CONNECTIONS_STATS(state) {
  state.connectionsWithStats = []
}

export function UPDATE_CONNECTIONS_PAGINATION(state, data) {
  state.connectionsPagination = data
}

export function CLEAR_CONNECTIONS_PAGINATION(state) {
  state.connectionsPagination = null
}

// POSTS
export function UPDATE_POSTS(state, data) {
  state.posts = data
}

export function UPDATE_POSTS_STATS(state, data) {
  state.postsStats = data
}

// CONNECTIONS
export function UPDATE_CONNECTIONS(state, data) {
  state.connections = data
}

export function CLEAR_CONNECTIONS(state) {
  state.connections = []
}

export function UPDATE_CONNECTIONS_COUNTER(state, data) {
  state.connectionsCounter = data
}

export function CLEAR_CONNECTIONS_COUNTER(state) {
  state.connectionsCounter = null
}

// ACCOUNTS
export function UPDATE_ACCOUNTS(state, data) {
  state.accounts = data
}

export function CLEAR_ACCOUNTS(state) {
  state.accounts = []
}

// PUBLIC PROFILE
export function UPDATE_ORGANISATION_PROFILE(state, data) {
  state.organisationProfile = data
}

export function CLEAR_ORGANISATION_PROFILE(state) {
  state.organisationProfile = null
}

export function UPDATE_ORGANISATION_PROFILE_POSTS(state, data) {
  state.organisationProfilePosts = data
}

export function CLEAR_ORGANISATION_PROFILE_POSTS(state) {
  state.organisationProfilePosts = []
}

export function UPDATE_ORGANISATION_PROFILE_POSTS_PAGINATION(state, data) {
  state.organisationProfilePostsPagination = data
}

export function CLEAR_ORGANISATION_PROFILE_POSTS_PAGINATION(state) {
  state.organisationProfilePostsPagination = null
}

export function UPDATE_ORGANISATION_PROFILE_CONNECTIONS(state, data) {
  state.organisationProfileConnections = data
}

export function CLEAR_ORGANISATION_PROFILE_CONNECTIONS(state) {
  state.organisationProfileConnections = []
}
